export function motoristasInRequest(params = {}) {
  return {
    type: '@motorista/MOTORISTAS_IN_REQUEST',
    payload: { params },
  };
}

export function findMotorista(idmotorista) {
  return {
    type: '@motorista/FIND_MOTORISTA',
    payload: { idmotorista },
  };
}

export function failedRequest() {
  return {
    type: '@motorista/FAILED_REQUEST',
  };
}

export function deleteMotorista(idmotorista, params) {
  return {
    type: '@motorista/DELETE_MOTORISTA',
    payload: { idmotorista, params },
  };
}

export function updateMotorista(motorista, params) {
  return {
    type: '@motorista/UPDATE_MOTORISTA',
    payload: { motorista, params },
  };
}

export function storeMotorista(motorista, params) {
  return {
    type: '@motorista/STORE_MOTORISTA',
    payload: { motorista, params },
  };
}

export function successInRequest(
  motoristas,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@motorista/SUCCESS_IN_REQUEST',
    payload: { motoristas, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(motorista) {
  return {
    type: '@motorista/SUCCESS_REQUEST',
    payload: { motorista },
  };
}

export function successRemove(params) {
  return {
    type: '@motorista/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@motorista/RECORD_FILTERING',
    payload: { params },
  };
}
